import collectionPoster from '@/assets/images/summer-haze-collection.png';

export const order = 3;

export default {
  collection_name: 'Summer Haze Collection',
  collection_desc:
    'Inspired by the soft warmth of summer light, the Summer Haze Collection features refined oak flooring with airy tones, subtle grain movement, and a calm, modern palette. Designed to brighten interiors and highlight the natural beauty of wood, each plank combines timeless elegance with the durability and craftsmanship Sakura Floors is known for.\n\nPerfect for creating light, inviting spaces, Summer Haze brings effortless warmth and contemporary style to both residential and commercial environments.',
  collection_poster:
    collectionPoster,
  products: [
    {
      product_name: 'Misty Harbor',
      sku: 'CG201-SH20',
      product_desc:
        'The Calm of the Coast.Where strength meets serenity. Inspired by the quiet, atmospheric mornings of a deep-water port, Misty Harbor brings a sophisticated, cool-toned foundation to the modern home. Its pale, silvery-ash hues are designed to expand your space, reflecting natural light to create an airy, open-concept feel.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Misty Harbor'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Wheat',
      sku: 'CG202-SH21',
      product_desc:
        'The Heart of the Home. Inspired by sun-soaked fields at peak harvest, Golden Wheat is designed to bring an immediate sense of organic comfort to your living space. Its radiant, medium-honey tones act as a natural light enhancer, turning even the quietest rooms into glowing, high-energy sanctuaries.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Wheat'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Sunset Glow',
      sku: 'CG203-SH22',
      product_desc:
        'The warmth of the day’s end, brought indoors. Sunset Glow is designed for those who want their home to radiate a welcoming, high-energy warmth. Inspired by the deep, amber hues of a horizon at dusk, this collection features a rich, multi-dimensional palette that breathes life into every room, turning your floor into a masterpiece of natural light.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Sunset Glow'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Ivory Grain',
      sku: 'CG204-SH23',
      product_desc:
        'Pure Luminosity. Ivory Grain is our most ethereal collection, designed to transform interiors into expansive, light-filled sanctuaries. With its stunningly pale, cream-and-alabaster palette, this floor acts as a canvas for modern living, reflecting every drop of natural light to create an atmosphere of pure, undisturbed serenity.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Ivory Grain'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Maple Grove',
      sku: 'CG205-SH24',
      product_desc:
        'The Natural Middle. Maple Grove is designed for the homeowner who wants the best of both worlds: the brightness of a light floor and the organic warmth of natural timber. With its soft, sun-bleached oatmeal palette, this collection brings an effortless, "lived-in" elegance to any space, acting as the perfect bridge between modern cool and traditional cozy.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove1.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove2.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove3.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove4.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove5.jpeg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove1.jpeg',
        },
      ],
      product_attributes: [
        ['Color', 'Maple Grove'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Hour',
      sku: 'CG206-SH25',
      product_desc:
        'Eternal Warmth. Golden Hour is more than just a floor; it\'s a mood. Inspired by that brief, magical moment when the sun dips low and everything turns to gold, this collection brings a permanent sense of warmth and optimism to your home. Its buttery, sun-kissed oak tones provide a radiant foundation that makes every room feel more alive.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour1.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour2.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour3.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour4.jpeg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour1.jpeg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Hour'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Horizon Prime',
      sku: 'SH30',
      product_desc:
        'Golden Horizon is designed to breathe radiant warmth and expansive light into modern living spaces. This premium collection features meticulously selected Prime-grade White Oak, emphasizing a remarkably clean, uniform appearance with minimal knots and a consistent, sophisticated grain pattern.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime%20Interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime%2002.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime%2003.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime%2004.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime%20Video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Horizon Prime'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Harvest Moon 9.5',
      sku: 'SH34',
      product_desc:
        'Designed to make spaces feel expansive, serene, and grounded, this premium collection features meticulously selected White Oak engineered to the highest standards. The Character-grade selection ensures a beautifully clean, refined aesthetic with minimal knots and a highly consistent, sophisticated grain pattern.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5%20Interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5_01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5_02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5_03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5_04.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5_05.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5%20Video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Harvest%20Moon%209.5/Harvest%20Moon%209.5_01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Harvest Moon 9.5'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Sunset Ash',
      sku: 'SH203AS',
      product_desc:
        'Bring the warm, glowing essence of twilight into your space with Sunset Ash. Known for its distinct, expressive grain patterns, this collection utilizes premium, meticulously graded Ash hardwood to deliver a look that is both deeply natural and highly refined. The Character-grade selection guarantees a clean, premium surface appearance, striking a perfect balance between bold character and modern sophistication.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Ash/Sunset%20Ash%20Interior%201.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Ash/Sunset%20Ash01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Ash/Sunset%20Ash02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Ash/Sunset%20Ash03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Ash/Sunset%20Ash04.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Ash/Sunset%20Ash05.jpg',
        },
      ],
      product_galleries_video: [],
      product_attributes: [
        ['Color', 'Sunset Ash'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Ash'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Spinel Ash',
      sku: 'SH33',
      product_desc:
        'Spinel Ash offers a sophisticated, contemporary twist on traditional hardwood flooring. Characterized by its sleek, mineral-toned gray hues, this premium Ash collection is perfect for spaces that demand a clean, architectural edge. Meticulously sourced and sorted, the Prime-grade selection guarantees an exceptionally uniform surface appearance with minimal knots, allowing the wood\'s striking, organic grain to take center stage without visual clutter.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Spinel%20Ash/Spinel%20Ash%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Spinel%20Ash/Spinel%20Ash1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Spinel%20Ash/Spinel%20Ash2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Spinel%20Ash/Spinel%20Ash3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Spinel%20Ash/Spinel%20Ash4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Spinel%20Ash/Spinel%20Ash%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Spinel%20Ash/Spinel%20Ash1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Spinel Ash'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Ash'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
  ],
};
